// 2026-05-26 - FormuLearning - Step 1 ADME 섹션 (4분할 카드)
// 파일 위치: frontend/src/features/step1/AdmeSection.tsx

interface AdmeItem {
  item: string
  value: string
}

import Collecting from './Collecting'

interface Props {
  adme: Record<string, unknown>
  loading?: boolean
}

const CATEGORIES = [
  { key: 'absorption', label: 'Absorption', color: 'var(--color-accent-purple)' },
  { key: 'distribution', label: 'Distribution', color: 'var(--color-accent-teal)' },
  { key: 'metabolism', label: 'Metabolism', color: 'var(--color-accent-purple)' },
  { key: 'excretion', label: 'Excretion', color: 'var(--color-accent-teal)' },
]

export default function AdmeSection({ adme, loading }: Props) {
  const hasData = adme && Object.keys(adme).length > 0

  return (
    <div className="mb-4">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">ADME Profile</h4>
      {!hasData ? (
        loading ? <Collecting /> : <p className="text-[11px] text-text-muted">표시할 ADME 정보가 없습니다.</p>
      ) : (
      <div className="panel-in">
      <div className="grid grid-cols-2 gap-2">
        {CATEGORIES.map(({ key, label, color }) => {
          const items = (adme[key] as AdmeItem[] | undefined) || []
          return (
            <div
              key={key}
              className="rounded-md border p-3"
              style={{ borderColor: 'var(--border-subtle)' }}
            >
              <div className="mb-2 flex items-center gap-1.5">
                <span className="block h-2.5 w-1 rounded-sm" style={{ backgroundColor: color }} />
                <span className="text-[11px] font-semibold text-text-primary">{label}</span>
              </div>
              {items.map((item, i) => (
                <div key={i} className="mb-1 flex justify-between gap-2">
                  <span className="text-[10px] text-text-secondary">{item.item}</span>
                  <span className="text-right text-[10px] text-text-body">{item.value}</span>
                </div>
              ))}
            </div>
          )
        })}
      </div>
      {adme.half_life != null && (
        <div className="mt-2 flex gap-6 text-[11px]">
          <span className="text-text-secondary">Half-life: <span className="text-text-body">{String(adme.half_life)}</span></span>
          {adme.food_effect != null && (
            <span className="text-text-secondary">Food Effect: <span className="text-text-body">{String(adme.food_effect)}</span></span>
          )}
        </div>
      )}
      </div>
      )}
    </div>
  )
}
